import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct'; // Ajuste o caminho conforme necessário
import { HistoricoMensagemResponse } from '../../responses/srv-notificacao/historico-mensagem.response';
import { GetMensagemHistoricoResponse } from '../../responses/srv-notificacao/get-mensagem-historico.response';
import { MensagemRequest } from '../../requests/srv-notificacao/mensagem-request.request';
import { ListAllMensagemRequest } from '../../requests/srv-notificacao/list-all-mensagem.request';


@Injectable({
  providedIn: 'root',
})
export class MensagemAdminService extends CommonService {
  // Ajuste a URL base conforme a configuração do seu environment.ts
  // Baseado na rota [Route("[controller]")] onde controller é MensagemAdmin
  private readonly apiUrl: string = environment.urlApiSrvNotificacao + 'MensagemAdmin';

  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  /**
   * Endpoint para listar notificações enviadas (Histórico).
   * Corresponde a: [HttpPost] /MensagemAdmin/getAll
   * @param request Filtros de pesquisa (título, data inicio, data fim).
   */
  public getAll(request: ListAllMensagemRequest, paginaAtual: number = 0): Observable<HistoricoMensagemResponse> {
    const url = `${this.apiUrl}/getAll?paginaAtual=${paginaAtual}`;
    return this.httpClient
      .post<HistoricoMensagemResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /**
   * Endpoint para buscar os detalhes de uma mensagem pelo ID.
   * Corresponde a: [HttpGet] /MensagemAdmin/idMensagem/{idMensagem}
   * @param idMensagem ID da mensagem.
   */
  public getById(idMensagem: number): Observable<GetMensagemHistoricoResponse> {
    const url = `${this.apiUrl}/idMensagem/${idMensagem}`;
    return this.httpClient
      .get<GetMensagemHistoricoResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /**
   * Endpoint para criar uma nova mensagem (notificação).
   * Corresponde a: [HttpPost] /MensagemAdmin
   * @param request Dados da nova mensagem e lista de usuários.
   */
  public post(request: MensagemRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /**
   * Endpoint para deletar (logicamente) uma mensagem.
   * Corresponde a: [HttpDelete] /MensagemAdmin/idMensagem/{idMensagem}?motivo=...
   * @param idMensagem ID da mensagem a ser excluída.
   * @param motivo Motivo da exclusão.
   */
  public delete(idMensagem: number, motivo: string): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/idMensagem/${idMensagem}`;
    
    let params = new HttpParams();
    if (motivo) {
        params = params.append('motivo', motivo);
    }

    return this.httpClient
      .delete<ReturnStruct>(url, { ...this.addHeaderToken(), params })
      .pipe(catchError(this.handleError));
  }
}